module.exports = __webpack_public_path__ + "static/media/carrossel5.d11faa1e.jpg";